import { Injectable } from '@angular/core';
import {InitData} from "../../interfaces/visa-src/InitData";
import {Observable} from "rxjs";
import {ConsumerIdentityRequest} from "../../interfaces/visa-src/ConsumerIdentityRequest";
import {SrcProfile} from "../../interfaces/visa-src/SrcProfile";
import {CompleteIdentityValidationRequest} from "../../interfaces/visa-src/CompleteIdentityValidationRequest";
import {Checkout} from "../../interfaces/visa-src/Checkout";
import {IsRecognizedResponse} from "../../interfaces/visa-src/IsRecognizedResponse";
import {IdentityLookupResponse} from "../../interfaces/visa-src/IdentityLookupResponse";
import {InitiateIdentityValidationResponse} from "../../interfaces/visa-src/initiateIdentityValidationResponse";
import {SrcProfileReturns} from "../../interfaces/visa-src/SrcProfileReturns";
import {CompleteIdentityValidationResponse} from "../../interfaces/visa-src/CompleteIdentityValidationResponse";
import {VisaCheckoutResponse} from "../../interfaces/visa-src/VisaCheckoutResponse";
import {ClickToPayApiClass} from "../../api/click-to-pay/click-to-pay.api.class";
import {Card} from "../../interfaces/visa-src/Card";
import {SrcProfileRequest} from "../../interfaces/SrcProfileRequest";
import {VisaCheckoutEncodedResponse} from "../../interfaces/visa-src/VisaCheckoutEncodedResponse";

@Injectable({
  providedIn: 'root'
})
export class ClickToPayService {

  constructor(
    private clickToPayApi: ClickToPayApiClass
  ) { }

  public initializePayment(type, sessionToken: string): Observable<any> {
    return this.clickToPayApi.initializePayment(type, sessionToken);
  }

  public checkSRCTdsRequired(sessionToken: string): Observable<any> {
    return this.clickToPayApi.checkSRCTdsRequired(sessionToken);
  }

  public getEncryptedCardPayload(card: Card, sessionToken: string): Observable<any> {
    return this.clickToPayApi.getEncryptedCardPayload(card, sessionToken);
  }

  // audit

  // audit requests


  public auditInitDataRequest(initData: InitData, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditInitDataRequest(initData, sessionToken);
  }

  public auditIdentityLookupRequest(identityLookup: ConsumerIdentityRequest, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditIdentityLookupRequest(identityLookup, sessionToken);
  }

  public auditSrcProfileRequest(srcProfileRequest: SrcProfileRequest, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditSrcProfileRequest(srcProfileRequest, sessionToken);
  }

  public auditCompleteIdentityValidationRequest(completeIdentityValidationRequest: CompleteIdentityValidationRequest, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditCompleteIdentityValidationRequest(completeIdentityValidationRequest, sessionToken);
  }

  public auditCheckoutValidationRequest(checkout: Checkout, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditCheckoutValidationRequest(checkout, sessionToken);
  }

  // audit responses

  public auditIsRecognizedResponse(isRecognizedResponse: IsRecognizedResponse, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditIsRecognizedResponse(isRecognizedResponse, sessionToken);
  }

  public auditIdentityLookupResponse(identityLookupResponse: IdentityLookupResponse, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditIdentityLookupResponse(identityLookupResponse, sessionToken);
  }

  public auditIdentityValidationResponse(identityValidationResponse: InitiateIdentityValidationResponse, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditIdentityValidationResponse(identityValidationResponse, sessionToken);
  }

  public auditSrcProfileResponse(srcProfileReturns: SrcProfileReturns, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditSrcProfileResponse(srcProfileReturns, sessionToken);
  }

  public auditCompleteIdentityValidationResponse(completeIdentityValidationResponse: CompleteIdentityValidationResponse, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditCompleteIdentityValidationResponse(completeIdentityValidationResponse, sessionToken);
  }

  public auditCheckoutValidationResponse(checkoutResponse: VisaCheckoutEncodedResponse, sessionToken: string): Observable<any> {
    return this.clickToPayApi.auditCheckoutValidationResponse(checkoutResponse, sessionToken);
  }
}
